import { VFC, useState } from "react";
import { Divider, Popover } from "antd";
import Button from "@scalian-consulting-oneui/button";

import { useAuth } from "../context/AuthContext";
import { formatPhoneNumber, getFullName } from "../helpers";
import { Copy, Mail, Phone } from "./icons";
import { successMessage } from "../helpers/message";

const HeaderWareHouseInfos: VFC = () => {
    const { user } = useAuth();
    const { warehouse } = user || {};
    const [phoneOpen, setPhoneOpen] = useState(false);
    const [mailOpen, setMailOpen] = useState(false);

    const hidePhone = () => {
        setPhoneOpen(false);
    };

    const handlePhoneOpenChange = (newState: boolean) => {
        setPhoneOpen(newState);
    };

    const hideMail = () => {
        setMailOpen(false);
    };

    const handleMailOpenChange = (newState: boolean) => {
        setMailOpen(newState);
    };

    if (!warehouse) {
        return null;
    }

    return (
        <div className="flex items-center leading-5">
            <Divider type="vertical" className="!mx-24 !h-32" />
            <div className="mr-16 flex gap-32">
                <div>
                    <p className="text-2xs font-extrabold uppercase text-brand-neutral-grey">Votre entrepôt</p>
                    <p className="text-base font-bold text-brand-blue-600">{warehouse.fields?.warehouse}</p>
                </div>
                <div>
                    <p className="text-2xs font-extrabold uppercase text-brand-neutral-grey">Contact entrepôt</p>
                    <p className="text-base font-bold text-brand-blue-600">{getFullName(warehouse.fields) ?? "-"}</p>
                </div>
            </div>
            <div className="flex gap-8">
                <Popover
                    open={phoneOpen}
                    onOpenChange={handlePhoneOpenChange}
                    content={
                        <span className="flex items-center gap-16">
                            {formatPhoneNumber(String(warehouse.fields?.phoneNumber))}
                            <Copy
                                onClick={() =>
                                    navigator.clipboard.writeText(String(warehouse.fields?.phoneNumber)).then(() => {
                                        hidePhone();
                                        successMessage({
                                            content: "Numéro de téléphone copié dans le presse-papier",
                                        });
                                    })
                                }
                            />
                        </span>
                    }
                >
                    <Button size="small" type="secondary" iconOnly={<Phone />} />
                </Popover>
                <Popover
                    open={mailOpen}
                    onOpenChange={handleMailOpenChange}
                    content={
                        <span className="flex items-center gap-16">
                            {warehouse.fields?.email}
                            <Copy
                                onClick={() =>
                                    navigator.clipboard.writeText(String(warehouse.fields?.email)).then(() => {
                                        hideMail();
                                        successMessage({ content: "Mail copié dans le presse-papier" });
                                    })
                                }
                            />
                        </span>
                    }
                >
                    <Button size="small" type="secondary" iconOnly={<Mail />} />
                </Popover>
            </div>
            <Divider type="vertical" className="!mx-24 !h-32" />
        </div>
    );
};

export default HeaderWareHouseInfos;
